// Generated by CoffeeScript 2.7.0
var EditCascadedSelectChoiceModal;

import Modal from 'trunks/vue/admin/components/modals/modal.js';

export default EditCascadedSelectChoiceModal = Vue.extend({
  components: {
    'modal': Modal
  },
  props: {
    title: {
      type: String,
      default: '新增选项'
    },
    cascadedSelectId: {
      type: Number
    },
    parentId: {
      type: Number,
      default: null
    },
    node: {
      type: Object
    },
    callback: {
      type: Function
    }
  },
  data: function() {
    var ref;
    return {
      valid: true,
      cascadedSelectName: (ref = this.node) != null ? ref.name : void 0
    };
  },
  template: `<modal :title="title"
       extendClass="cascaded-select-modal"
       size='small'
       @ensureClicked="ensureClickedFunc"
       @cancelClicked="cancelClickedFunc"
       ref="cascadedSelectModalRef">
  <template>
    <div class="modal-body mt-5">
      <div :class="{ 'has-error': !valid }"
           class="form-field required">
        <div class="form-field-head mr-2">
          <div class="form-field-title">选项内容</div>
        </div>
        <div class="form-field-input-container">
          <div class="form-field-input">
            <input v-model.trim="cascadedSelectName"
                   class="form-field-value"
                   placeholder="请输入选项内容"
                   type="text">
          </div>
          <div class="message">不能为空</div>
        </div>
      </div>
    </div>
  </template>
</modal>`,
  computed: {
    doRequestUrl: function() {
      if (this.node) {
        return `/admin/choices/${this.node.id}`;
      } else {
        return "/admin/choices";
      }
    },
    alertifyText: function() {
      if (this.node) {
        return {
          success: "编辑选项成功",
          error: "编辑选项失败"
        };
      } else {
        return {
          success: "新增选项成功",
          error: "新增选项失败"
        };
      }
    },
    doRequestType: function() {
      if (this.node) {
        return "put";
      } else {
        return "post";
      }
    }
  },
  methods: {
    getData: function() {
      if (this.node) {
        return {
          choice: {
            name: this.cascadedSelectName,
            parent_id: this.parentId
          }
        };
      } else {
        return {
          cascaded_select_id: this.cascadedSelectId,
          choice: {
            name: this.cascadedSelectName,
            parent_id: this.parentId
          }
        };
      }
    },
    ensureClickedFunc: function() {
      this._validate();
      if (!this.valid) {
        this.$refs.cascadedSelectModalRef.open();
        return;
      }
      return this.doRequest();
    },
    doRequest: function() {
      return Skylark.Libs.Ajax[this.doRequestType](this.doRequestUrl, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: this.getData(),
        success: (res) => {
          Skylark.Bridge.newAlertify(this.alertifyText.success, {
            type: 'success'
          });
          return this.callback(res);
        },
        error: function() {
          return Skylark.Bridge.newAlertify(this.alertifyText.error, {
            type: 'error'
          });
        }
      });
    },
    cancelClickedFunc: function() {
      return this.cascadedSelectName = '';
    },
    _validate: function() {
      return this.valid = Boolean(this.cascadedSelectName);
    }
  }
});
